import { createTheme } from '@mui/material';
import { ThemeProvider } from 'styled-components';
import "../../components/CommunicationTemplete/CommunicationTemplate.css";
import GroupMilestones from '../../components/GrouppingMilestone/GrouppingMilestone';


const defaultTheme = createTheme();

const ManageMilestoneGrouping = () => {
  return (
    <ThemeProvider theme={defaultTheme}>
      <div className="ctpl-page-header">
        <div className="ctpl-title-col">
          <h1> Manage Milestone Grouping</h1>
          <p>Group first & last-mile milestones for air and ocean shipments.</p>
        </div>
      </div>

      <GroupMilestones />
    </ThemeProvider>
  );
};

export default ManageMilestoneGrouping;